module.exports = __webpack_public_path__ + "static/media/pracitioner_app-icon.ceb00d5b.png";